import React from 'react';
import { TTLogo, mobDoc, MirLogo } from '~routes/login-page/svgs';
import { connect } from 'react-redux';
import { logUser, logIn } from '~redux_related/user/actionCreators';
import LoginForm from './login-form';
import ResetForm from './reset-password-form';
import NewPasswordForm from './new-password-form';
import '~routes/login-page/style.scss';
import SK_LOGO from "../../../img/sk_logo_black.png";

function Login({ isMobile, isFetching, redirectPath, logUser, logIn }) {
    console.log('+++LOGIN PAGE+++');
    const [state, switchForms] = React.useState(false);
    const passwordRecovery = React.useMemo(() => {
        const pageParams = new URLSearchParams(document.location.search.substring(1));
        if (pageParams instanceof Object) {
            return pageParams.get('password_recovery') || '';
        }
        return '';
    }, []);

    const isTTSu = window.location.host === 'tracktrack.su';

    return (
        <div className="login-page__form">
            <div className="login-page__inner-container">
                {!isTTSu && (
                    <div className="login-page__logos">
                        <div className="login-page__company-logo">{TTLogo}</div>
                        <a
                            href="http://www.sk.ru"
                            target="_blank"
                            rel="noreferrer noopener"
                            className="login-page__sk-logo"
                        >
                            <img src={SK_LOGO} alt="SK Resident" height="42" />
                        </a>
                    </div>
                )}

                {isTTSu && (
                    <div className="login-page__for-rzd-logos">
                        <div className="login-page__for-rzd-logo">{MirLogo}</div>
                    </div>
                )}

                <div className="login-page__inner-wrap">
                    {state && !passwordRecovery && (
                        <ResetForm isMobile={isMobile} backCallback={() => switchForms(false)} />
                    )}
                    {!state && !passwordRecovery && (
                        <LoginForm
                            isMobile={isMobile}
                            switchForms={switchForms}
                            isFetching={isFetching}
                            logUser={logUser}
                            redirectPath={redirectPath}
                        />
                    )}
                    {passwordRecovery && (
                        <NewPasswordForm
                            isMobile={isMobile}
                            isFetching={isFetching}
                            logIn={logIn}
                            redirectPath={redirectPath}
                        />
                    )}
                </div>

                {isMobile && !isTTSu && (
                    <a href="/docs/TrackTrackPresentation.pdf" download className="login-page__file">
                        {mobDoc}
                        <span className="login-page__file-text">Скачать презентацию</span>
                    </a>
                )}
            </div>
            <div className="login-page__bottom">
                <div className="login-page__shadow" />
                <div className="login-page__support">
                    <span className="login-page__support-title">Поддержка клиентов</span>
                    <span className="login-page__support-manager">Антон Митяев</span>
                    <div className="login-page__support-contacts">
                        <a href="mailto:support@mir-initiative.com">support@mir-initiative.com</a>
                        <a href="tel:+7 (926) 249-40-50">+7 (926) 249-40-50</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
    isFetching: state.user.isUserFetching,
    redirectPath: state.ui.redirectPath,
});

const mapDispatchToProps = (dispatch) => ({
    logUser: ({ username, password }) => {
        console.log('+++DISPATCH LOG+++', username, password);
        dispatch(logUser({ username: username, password: password }));
    },
    logIn: (user) => dispatch(logIn(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/routes/login-page/login/index.js